import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { object } from 'yup';
import axiosinstances from '../../../Helper/useAxios';
import '../../Profile/profile.css'

export default function DmtSupplierConfigDetails() {
    const location = useLocation()
    //console.log('location', location)
    const dmtConfgData = location?.state
    //console.log('dmtConfgData', dmtConfgData)
	const navigate = useNavigate();
	const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
	const [profileDetails, setProfileDetails] = useState()
	
	
	
	
	const pancardDetails = (check) =>{
		const pancardId = profileDetails?.kycInfo?.docs !== undefined && profileDetails?.kycInfo?.docs !== null && Array.isArray(profileDetails?.kycInfo?.docs) && profileDetails?.kycInfo?.docs.length > 0 &&
		profileDetails?.kycInfo?.docs.filter((val)=> val.type === check)
		return pancardId[0]?.id
	}
	const toHistory = () =>{
		navigate(`/account-history/${id}`)
	}

  return (
<React.Fragment>
    <div class="mid">
	<div class="container-fluid">		
		<div class="head">
			<h3>Details</h3>
			<button class="btn" type="button" onClick={()=>navigate(-1)} >Back</button>
		</div>
		
		<div class="usercard">
			<div class="row">
				{/*  */}
				
				
				<div class="col-12">
					<div class="rightpro">
						<div class="adrsdtl">
							<h4>DMT Supplier Config Details</h4>
							
							<p>ID:</p>
							<h6>{ dmtConfgData?.id !== undefined && dmtConfgData?.id}</h6>
							
							<p>Name:</p>
							<h6>{dmtConfgData?.name !== undefined && dmtConfgData?.name}</h6>
							
							<p>payoutUrl:</p>
							<h6>{dmtConfgData?.payoutUrl !== undefined && dmtConfgData?.payoutUrl}</h6>
							
							<p>URL:</p>
							<h6>{dmtConfgData?.url !== undefined && dmtConfgData?.url}</h6>
							
							
							<p>Operato Details:</p>
                            <h6>
                                {dmtConfgData?.operatorMapping !== undefined &&  dmtConfgData?.operatorMapping !== null &&  dmtConfgData?.operatorMapping !== '' &&
                               Object.keys(dmtConfgData?.operatorMapping).length !== 0 && 
                               Object.keys(dmtConfgData?.operatorMapping).map(key=>{
                                <h6>{key}</h6> 
                               if( Object.keys(dmtConfgData?.operatorMapping[key]).length > 0){
                                 return   Object.keys(dmtConfgData?.operatorMapping[key]).map((operators=>{
                                        
                                     return(<>
                                        
                                        <p>{`key ${key} :-${operators}  ${dmtConfgData?.operatorMapping[key][operators]}`}</p>
                                     </> )

                                    }))  
                                } else {
                                    return <p>{key}</p>
                                }
                               })
                                }
                            </h6>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

</React.Fragment>
  )
}
